import React from 'react';
import '../../index.css'; // 假设CSS样式保存在这个文件中

const FastFoodExample = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">使用案例文案-快餐(适用于叫号取餐场景, 如汉堡店, 奶茶店, 等)</h1>

      <div className="section">
        <p className="store-info">Tealicious是一家类似蜜雪冰城、CoCo、书亦烧仙草的连锁奶茶店, 服务流程为: </p>
        <ol>
          <li>1.	客人在前台点餐或者手机扫码下单, 并完成付款.</li>
          <li>2.	前台打印小票给客人, 同时后厨出票.</li>
          <li>3.	后厨出餐后服务员叫号, 客人凭票取餐.</li>
        </ol>
        <p>此外客户还有以下需求:</p>
        <ol>
          <li>1.	会员注册需求, 针对老客户会提供充值1000赠送300的优惠活动.</li>
          <li>2.	税务需求, 需要系统可以自动计税, 并体现在小票上.</li>
          <li>3.	部分菜品只有周末早上供应, 希望超过时间自动下架.</li>
          <li>4.	餐厅有若干位合伙人, 合伙人希望可以看到餐厅的账目情况.</li>
          <li>5.	希望可以导出订单明细来作进一步数据分析.</li>
        </ol>
      </div>

      <p>
        了解用户需求后, 我们给出了以下方案:
      </p>

      <div className="section">
        <h2>角色分工</h2>
        <ol>
          <li>店长用手机登录店长账号, 可以管理餐厅设置, 查看报表等, 但是不需要店长直接操作订单. {/*[后面跟一张截图]*/}</li>
          {/* <img src="./quick/img.png"  alt="" style={{width: '400px'}} /> */}
          <li>员工在电脑上登录前台账号, 前台账号负责连接打印机以及操作订单, 比如下单, 结账、打印小票等. {/*[后面跟一张截图]*/}</li>
          {/* <img src="./quick/img_2.png"  alt="" style={{width: '400px'}} /> */}
          <li>合伙人用自己的手机登录合伙人账号, 合伙人账号可以看到餐厅的经营信息, 但是无法修改餐厅设置, 也无法操作订单. {/*[后面跟一张截图]*/}</li>
          {/* <img src="./quick/img_3.png"  alt="" style={{width: '400px'}} /> */}
        </ol>
      </div>

      <div className="section">
        <h2>打印机设置</h2>
        <p>前台部署一台收银打印机来打印收银小票给客人, 后厨部署一台打印机.</p>
        {/*[放打印机设置截图, 和小票截图]*/}
        <img src="./quick/img_4.png"  alt="" />
        {/* <img src="./quick/img_5.png"  alt="" /> */}

      </div>

      <div className="section">
        <h2>会员设置</h2>
        <p>在会员设置中设置储值规则, 前台和服务员都可以帮助客人储值.</p>
        <img src="./quick/img_18.png"  alt="" style={{width: '1000px'}} />
        {/* <img src="./quick/img_19.png"  alt="" /> */}
        {/*[放设置截图]*/}
      </div>

      <div className="section">
        <h2>设置税务</h2>
        {/*[放税务设置截图, 结账页面截图, 小票图片]*/}
      </div>

      <div className="section">
        <h2>分时菜单</h2>
        <p>设置部分菜品只有周日早上出现.</p>
        {/*<img src="./quick/img_7.png"  alt="" />*/}
        <img src="./quick/img_10.png" style={{maxWidth: "1400px"}} alt="" />
        {/*[设置页面截图]*/}
      </div>

      <div className="section">
        <h2>导出订单</h2>
        <p>方便餐厅合伙人和店长对销售数据进行深入分析。</p>
        {/*[excel 截图]*/}
      </div>

      {/* <div className="section">
        <h2>后厨显示系统(KDS)</h2>
        <p>后厨除了通过打印小票获取订单信息之外, 我们也支持使用后厨显示系统(KDS)来展示后厨订单,
          厨师可以通过大屏幕来更直观的了解订单情况.
          <a href="link_to_kds_details">点击这里来查看详情</a>.</p>
        <img src="./quick/img_9.png"  alt="" /> */}
        {/*[这里放一张后厨KDS的示意照片, 可以用麦当劳之类的]*/}
      {/* </div> */}

      {/*[在此处可以根据实际内容继续添加其他必要的section]*/}

    </div>
  );
};

export default FastFoodExample;
